const hostname = window.location.hostname;

export const SERVER_URL =
  hostname === 'localhost' || hostname === '127.0.0.1'
    ? 'http://localhost:4000'
    : 'https://api.everyid.com';

export const BUCKET_LIST = 'every722.s3.us-east-2.amazonaws.com';
